import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './navbar.css';
import analytics from '../../analytics';

const Navbar = ({ onLogoClick, isPaidUser }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNavClick = (section, e) => {
    setIsMobileMenuOpen(false);
    // Handle navigation based on section
    if (section === 'home') {
      e.preventDefault();
      window.location.href = '/';
    }
  };

  const handleAIAdvisorClick = () => {
    setIsMobileMenuOpen(false);
    // Track AI Stock Advisor click from navbar
    analytics.trackAIAdvisorClick([], 'navbar');
  };

  return (
    <nav className="modern-navbar">
      <div className="navbar-container">
        {/* Logo Section */}
        <div className="navbar-logo" onClick={onLogoClick}>
          <span className="logo-text">Stocklele</span>
        </div>

        {/* Desktop Navigation Links */}
        <ul className={`navbar-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          <li className="navbar-item">
            <a href="/" className="navbar-link" onClick={(e) => handleNavClick('home', e)}>
              <span className="nav-icon">🏠</span>
              Home
            </a>
          </li>
          <li className="navbar-item">
            <Link to="/ai-stock-advisor" className="navbar-link ai-advisor-link" onClick={handleAIAdvisorClick}>
              <span className="nav-icon">👑</span>
              AI Stock Advisor
              <span className="lock-icon">🔒</span>
            </Link>
          </li>
          {isPaidUser && (
            <li className="navbar-item">
              <span className="navbar-badge pro-badge">
                <span className="badge-icon">👑</span>
                Premium
              </span>
            </li>
          )}
        </ul>

        {/* Mobile Hamburger Menu */}
        <button
          className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
